/**
 * Csv Schema of CargaDestinatario
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaDestinatario} from '@/model/resource/CargaDestinatario'

/* TODO: review generated schema */
export class CsvCargaDestinatarioSchema extends Schema {
  readonly name = 'CsvCargaDestinatario'

  readonly fieldSet: FieldSet<CargaDestinatario> = {
    carga: schema => schema.model.carga?.$id ?? null,
    endereco: schema => schema.model.endereco?.$id ?? null,
    nome: schema => schema.model.nome,
    cpfCnpj: schema => schema.model.cpfCnpj,
    telefone: schema => Helper.phone(schema.model.telefone),
    indicadorIe: schema => schema.model.indicadorIe,
    inscricaoEstadual: schema => schema.model.inscricaoEstadual,
    inscricaoSuframa: schema => schema.model.inscricaoSuframa,
    im: schema => schema.model.im,
    email: schema => schema.model.email,
  }
}
